<template>
  <v-container class="ma-0 pa-0" fluid>
    <template>
      <v-toolbar color="fill">
        <v-col cols="auto" class="mr-auto pl-0">
          <router-link class="primary--text" :to="{ path: '/promos'}" style="text-decoration:none;">
            <v-icon color="primary">mdi-chevron-left</v-icon>Return to Promotions
          </router-link>
        </v-col>
        <v-col v-if="tab !== 0">
          <span>
          <span class="text-caption py-0">
            <b>Promo Name:</b> {{ promo.name }}
          </span>
            <v-icon color="#000" class="display-dot" aria-hidden="true">mdi-circle-small</v-icon>
            <span class="text-caption py-0">
              <b>Promotion Number:</b> {{ promo.promo_number }}
            </span>
            <v-icon color="#000" class="display-dot" aria-hidden="true">mdi-circle-small</v-icon>
            <span class="text-caption py-0">
              <b>Promo Category:</b> {{ promoTypeDisplayName }}
            </span>
            <v-icon color="#000" class="display-dot" aria-hidden="true">mdi-circle-small</v-icon>
            <span v-if="promo.status" class="text-caption py-0">
              <b>Status:</b> {{ promo.status.status.name }}
            </span>
            <template v-if="promo.cloned_from_promo_id">
              <v-icon color="#000">mdi-circle-small</v-icon>
              <span class="text-caption py-0">
                <router-link
                  :to="{ name: 'Promo', query: { id: promo.cloned_from_promo_id }}"
                  class="primary--text"
                  style="text-decoration: none">
                  Parent <v-icon small color="primary">mdi-launch</v-icon>
                </router-link>
              </span>
            </template>
          </span>
        </v-col>
        <span class="ml-auto">
          <PromoActions
              :value="tab"
              :id="id"
              :readOnlyPromo="readOnlyPromo"
              :showContractDownloadButton="showContractDownloadButton"
              :isPromoStatusAdmin="isPromoStatusAdmin"
              :showVendorApproval="showVendorApproval"
              :isPromoVendorAdmin="isPromoVendorAdmin"
              :showShuttleButton="showShuttleButton"
              :showComplexMerging="showComplexMerging"
              :showMergedPromos="showMergedPromos"
              :itemsDisabled="itemsDisabled"
              :promoNameEditException="promoNameEditException"
              :categoryManagerIsDisabled="categoryManagerIsDisabled"
              :promo="promo"
              :saving="saving"
              @openCloneModal="showCloneModal = true"
              @openStatusModal="showStatusModal = true"
              @openShuttleModal="showShuttleModal = true"
              @openVendorApprovalModal="vendorApprovalModal = true"
              @openConfirmationModal="confirmationModal = true"
              @openComplexMergingModal="complexMergingModal = true"
              @openMergedPromosModal="mergedPromosModal = true"
              @downloadContract="downloadContract"
              @downloadPromo="download"
              @savePromo="savePromo"
              >
          </PromoActions>
        </span>
      </v-toolbar>
      <v-tabs
        grow 
        dark
        background-color="primary"
        hide-slider
        :active-class="'active'"
        v-model="tab">
        <v-tab>Promotion Details</v-tab>
        <v-tab :disabled="!existingPromo">Group / Store</v-tab>
        <v-tab :disabled="!existingPromo || itemsDisabled">Items</v-tab>
      </v-tabs>
      <keep-alive>
        <span v-if="tab === 0">
          <div class="mx-8 mt-8">
            <v-tooltip v-if="isInFlight" top>
              <template v-slot:activator="{ on }">
                <v-icon color="action" v-on="on" class="mr-4"  >
                  mdi-airplane-takeoff
                </v-icon>
              </template>
              <span>Promotion is In Flight</span>
            </v-tooltip>
            <span class="text-body-2">
              <b>Promotion Category:</b> {{ promoTypeDisplayName }}
            </span>
            <span
              v-if="promo.status"
              class="text-body-2 ml-4">
                <b>Status:</b> {{ promo.status.status.name }}
            </span>
            <template v-if="promo.audit">
              <span class="ml-4 text-body-2">
                <b>Last updated by:</b> {{ promo.audit.updated_by }}
              </span>
              <span class="ml-4 text-body-2">
                <b>Created On:</b> {{ $config.formatDate(promo.audit.created_on) }}
              </span>
              <span class="ml-4 text-body-2">
                <b>Updated On:</b> {{ $config.formatDate(promo.audit.updated_on) }}
              </span>
            </template>
            <span v-if="promo.cloned_from_promo_id"
              class="ml-4 text-body-2">
              <router-link
                :to="{ name: 'Promo', query: { id: promo.cloned_from_promo_id }}"
                class="primary--text"
                style="text-decoration: none">
                Parent <v-icon small color="primary">mdi-launch</v-icon>
              </router-link>
            </span>
            <div class="mt-4">
              <PromoHeader
                ref="promoTypeFields"
                :promo_type_constant="promo_type_constant"
                :promo="promo"
                :readOnlyPromo="readOnlyPromo"
                :showLumpSum="showLumpSum"
                :promoNameEditException="promoNameEditException"
                :categoryManagerIsDisabled="categoryManagerIsDisabled">
              </PromoHeader>
            </div>
            <v-form ref="form">
            <v-row class="pt-4">
              <v-col cols="4" class="px-0 py-0">
                <PromoDates
                  ref="promoDates"
                  :promo="promo"
                  :readOnlyPromo="readOnlyPromo">
                </PromoDates>
              </v-col>
              <v-col v-if="showAdDateField" cols="2">
                <v-menu
                  v-model="ad_dt_picker"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="promo.ad_date"
                      label="Ad Date"
                      ref="add_dt"
                      type="date"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      background-color="#fff"
                      outlined
                      :clearable="!readOnlyPromo"
                      :readonly="readOnlyPromo"
                      :rules="[isValidAdDate]"
                      v-on="!readOnlyPromo ? on : null"
                      v-bind="attrs">
                    </v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="promo.ad_date"
                    color="action"
                    :show-current="promo.start_dt || true"
                    no-title>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-if="promoIsAdCategory" cols="2">
                <v-menu
                  v-model="offer_start_dt_picker"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="promo.offer_start_date "
                      label="Perishable Offer Start Date"
                      ref="offer_start_date "
                      type="date"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      background-color="#fff"
                      outlined
                      :rules="[isValidOfferStartDate]"
                      :clearable="!readOnlyPromo"
                      :readonly="readOnlyPromo"
                      v-on="!readOnlyPromo ? on : null"
                      v-bind="attrs">
                    </v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="promo.offer_start_date"
                    color="action"
                    :max="promo.offer_end_date || null"
                    :allowed-dates="allowedOfferStartDates"
                    no-title>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-if="promoIsAdCategory" cols="2">
                <v-menu
                  v-model="offer_end_dt_picker"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="promo.offer_end_date"
                      label="Perishable Offer End Date"
                      ref="offer_end_date"
                      type="date"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      background-color="#fff"
                      outlined
                      :rules="[isValidOfferEndDate]"
                      :clearable="!readOnlyPromo"
                      :readonly="readOnlyPromo"
                      v-on="!readOnlyPromo ? on : null"
                      v-bind="attrs">
                    </v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="promo.offer_end_date"
                    :min="promo.offer_start_date || null"
                    color="action"
                    :allowed-dates="allowedOfferEndDates"
                    no-title>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col :cols="promoIsAdCategory ? 2 : 4" class="px-1">
                <v-select
                  label="Promotion Type"
                  item-value="id"
                  item-text="name"
                  item-color="action"
                  :items="billingModeOptions"
                  v-model="promo.billing_mode"
                  background-color="#fff"
                  :rules="[isValidBillingMode]"
                  :readonly="readOnlyPromo"
                  dense
                  hide-details="auto"
                  outlined
                  return-object>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="px-1">
                <PromoVendorSelect
                  ref="vendorSelect"
                  :promoBillingParties="promoBillingParties"
                  :readOnlyPromo="readOnlyPromo"
                  :promo="promo"
                  @queueChanges="queueBillingPartyChanges">
                </PromoVendorSelect>
              </v-col>
              <v-col cols="4" class="px-1">
                <PromoRelatedSubvendorSelect
                  ref="subvendorSelect"
                  :promoBillingParties="promoBillingParties"
                  :promoSelectedSubvendors="promoSelectedSubvendors"
                  :readOnlyPromo="readOnlyPromo"
                  :billingPartiesBuffer="billingPartiesBuffer"
                  :allowMultipleSubvendors="allowMultipleSubvendors"
                  @subvendorSelected="handleSubvendorSelected">
                </PromoRelatedSubvendorSelect>
              </v-col>
              <v-col v-if="showVendorInvoiceAndInternalBillingParty" cols="2" class="px-1">
                <v-autocomplete
                    v-model="promo.internal_billing_party_id"
                    label="Internal Billing Party"
                    :items="internalBillingParties"
                    item-text="name"
                    item-value="id"
                    item-color="action"
                    clearable
                    :disabled="(promo.promo_category && promo.promo_category.name === 'Ad Scan - ARG Spendback') || !promo.vendor_invoice_exclude || readOnlyPromo"
                    :rules=[internalBillingPartyRules]
                    hide-details="auto"
                    background-color="#fff"
                    dense
                    autocomplete="off"
                    outlined
                    hide-no-data>
                </v-autocomplete>
              </v-col>
              <v-col v-if="allowBillingEditing" cols="2">
                <v-menu
                  v-model="billing_week_dt_picker"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="promo.billing_week_start"
                      label="Billing Week"
                      ref="billing_week"
                      type="date"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      background-color="#fff"
                      outlined
                      :rules=[billingWeekStartRules]
                      :clearable="!readOnlyPromo"
                      :disabled="!promo.manual_bill"
                      :readonly="promo.manual_bill || readOnlyPromo"
                      v-on="!readOnlyPromo ? on : null"
                      v-bind="attrs">
                    </v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="promo.billing_week_start"
                    color="action"
                    :disabled="!promo.manual_bill"
                    :allowed-dates="allowedBillingWeekDates"
                    no-title>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-spacer/>
            <v-row>
              <v-col v-if="!isAMAPorEBA" cols="4" class="px-1">
                <v-text-field
                  v-model="promo.comments"
                  label="Missing Link Item Comments"
                  :disabled="readOnlyPromo"
                  dense
                  outlined
                  hide-details="auto"
                  background-color="#fff">
                </v-text-field>
              </v-col>
              <v-col v-if="showDigitalCoupon" cols="4" class="px-1">
                <v-text-field
                  v-model="promo.digital_coupon_note"
                  label="ARG Digital Coupon Value"
                  :disabled="!promo.digital_coupon || readOnlyPromo"
                  dense
                  outlined
                  :rules="[digitalCouponRules]"
                  hide-details="auto"
                  background-color="#fff">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-4" align="center">
              <v-col cols="2">
                <v-text-field 
                  v-if="!id"
                  dense
                  outlined
                  hide-details
                  background-color="#fff"
                  label="Promotion Number"
                  v-model="promo.promo_number">
                </v-text-field>
                <span v-else class="text-body-2">
                  <b>Promotion Number:</b> {{ promo.promo_number }}
                </span>
              </v-col>
              <v-col
                cols="auto"
                v-show="!limitAccessByRelatedVendors"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="Override Store Offset"
                    v-model="promo.override_store_offset"
                    :disabled="readOnlyPromo" />
                </v-layout>
              </v-col>
              <v-col
                cols="auto"
                v-show="!limitAccessByRelatedVendors"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="Override Store Ad Length"
                    v-model="promo.override_store_length"
                    :disabled="readOnlyPromo" />
                </v-layout>
              </v-col>
              <v-col
                cols="auto"
                v-show="promo.promo_category && promo.promo_category.scan_promotion"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="Enforce Compliance"
                    v-model="promo.enforce_compliance"
                    disabled />
                </v-layout>
              </v-col>
              <v-col
                cols="auto"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="Perishable"
                    v-model="promo.perishable"
                    :disabled="readOnlyPromo || (isPCAF || promo.dsd)" />
                </v-layout>
              </v-col>
              <v-col 
                cols="auto"
                v-if="showDigitalCoupon"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="ARG Digital Coupon"
                    v-model="promo.digital_coupon"
                    :disabled="readOnlyPromo" />
                </v-layout>
              </v-col>
              <v-col 
                cols="auto"
                v-if="showVendorInvoiceAndInternalBillingParty"
                class="py-0 mt-4">
                <v-layout>
                  <v-checkbox
                    color="checkbox"
                    class="mt-0"
                    height="30px"
                    label="Vendor Invoice Exclude"
                    v-model="promo.vendor_invoice_exclude"
                    :disabled="(promo.promo_category && promo.promo_category.name ==='Ad Scan - ARG Spendback') || readOnlyPromo" />
                </v-layout>
              </v-col>
              <v-row v-if="!isAMAPorEBA">
                <v-col
                  cols="auto"
                  v-if="isNonAllowancePromo"
                  class="py-0 mt-4">
                    <v-layout>
                      <v-checkbox
                        color="checkbox"
                        class="mt-0"
                        height="30px"
                        label="Private Label"
                        v-model="promo.private_label"
                        :disabled="readOnlyPromo" />
                    </v-layout>
                </v-col>
                <v-col 
                  cols="auto"
                  v-if="showDSD"
                  class="py-0 mt-4">
                    <v-layout>
                      <v-checkbox
                        color="checkbox"
                        class="mt-0"
                        height="30px"
                        label="DSD"
                        v-model="promo.dsd"
                        :disabled="readOnlyPromo || (promoIsDSDOffInvoice || promo.perishable)" />
                    </v-layout>
                </v-col>
                <v-col
                  cols="auto"
                  v-if="showSpecialAdLength"
                  class="py-0 mt-4">
                  <v-layout>
                    <v-checkbox
                      color="checkbox"
                      class="mt-0"
                      height="30px"
                      label="Special Ad Length"
                      v-model="promo.special_ad_length"
                      :disabled="readOnlyPromo">
                   </v-checkbox>
                  </v-layout>
                </v-col>
                <v-col
                  cols="auto"
                  v-if="allowBillingEditing"
                  class="py-0 mt-4">
                  <v-layout>
                    <v-checkbox
                      color="checkbox"
                      class="mt-0"
                      height="30px"
                      label="Manual Invoice"
                      v-model="promo.manual_bill"
                      :disabled="readOnlyPromo">
                   </v-checkbox>
                  </v-layout>
                </v-col>
              </v-row>
              <v-col cols="3"></v-col>
            </v-row>
            </v-form>
          </div>
        </span>
        <storeTable
          v-else-if="tab === 1"
          :panel_height="panelHeight - 36.5"
          :promo="promo"
          :readOnlyPromo="readOnlyPromo"
          :partyItemSources="partyItemSources"
          :upstreamPartyIds="upstreamPartyIds"
          :showLumpSum="showLumpSum"
          :refreshStores="refreshStores"
          :promoAllowances="promoAllowances"
          @enableItemsTab="itemsDisabled = false"
          @setPromoPartyIds="setPromoPartyIds"
          @updateItemSources="updatePartyItemSources"
          @updateShuttleEnabled="(val) => shuttleEnabled = val"
          @setPromoAllowances="(val) => promoAllowances = val"
          @getPromoStores="getPromoStores"
          @updateHistory="updatePromoHistory">
        </storeTable>
        <itemTable
          v-else
          :panel_height="panelHeight"
          :promo="promo"
          :readOnlyPromo="readOnlyPromo"
          :promo_type_constant="promo_type_constant"
          :item_sources="promoItemSources"
          :promoPartyIds="promoPartyIds"
          :vmc_sources="vmcSources"
          :vendorIds="vendorIds"
          :isPromoVendorAdmin="isPromoVendorAdmin"
          @updatePromoItems="updatePromoItems"
          @updateHistory="updatePromoHistory">
        </itemTable>
      </keep-alive>
      <v-dialog v-model="confirmationModal" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Are You Sure?
          </v-card-title>
          <v-card-text>
            Deleting a promo is a permanent action than cannot be undone. Are you sure you want to delete this promo?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1 white--text" @click="confirmationModal = false">
              No, don't delete!
            </v-btn>
            <v-btn :disabled="deleting" :loading="deleting" color="green darken-1 white--text" @click="deletePromo()">
              Yes, I am sure!
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <CloneModal
        v-model="showCloneModal"
        v-if="showCloneModal"
        :promo="promo"
        @success="initClonedPromo"
        @cancel="showCloneModal = false">
      </CloneModal>
      <ShuttleModal
        v-if="showShuttleModal"
        v-model="showShuttleModal"
        :promoPartyIds="promoPartyIds"
        :partyItemSources="partyItemSources"
        @close="showShuttleModal = false">
      </ShuttleModal>
      <StatusModal
        v-if="showStatusModal"
        v-model="showStatusModal"
        :promo="promo"
        :promoItems="promoItems"
        :promoPartyIds="promoPartyIds"
        :loadingItems="loadingItems"
        :vendorIds="vendorIds"
        :validLumpSums="validLumpSums"
        :lumpSumTotal="lumpSumTotal"
        :validSubvendorSelected="validSubvendorSelected"
        :validCategoryManagerSelected="validCategoryManagerSelected"
        :isPromoStatusAdmin="isPromoStatusAdmin"
        :readOnlyPromo="readOnlyPromo"
        :promoChangesAreSaved="promoChangesAreSaved"
        @initPromoItems="initPromoItems"
        :promoAllowances="promoAllowances"
        :promoStores="promoStores"
        @setPromoAllowances="(val) => promoAllowances = val"
        @refreshStores="refreshStores = true"
        @close="showStatusModal = false"
        @saved="statusSaved">
      </StatusModal>
      <VendorApprovalModal
        v-if="vendorApprovalModal"
        v-model="vendorApprovalModal"
        :promo="promo"
        :promoBillingParties="promoBillingParties"
        @close="vendorApprovalModal = false"
        @updateBillingParties="initBillingParties"
        @autoSubmit="submitVendorApprovedPromo"
        @updateHistory="updatePromoHistory">
      </VendorApprovalModal>
      <ComplexMergingModal
        v-if="complexMergingModal"
        v-model="complexMergingModal"
        :promo="promo"
        :promoParties="promoParties"
        :isMergedPromo="isMergedPromo"
        @close="complexMergingModal = false"
        @merged="goToPromo">
      </ComplexMergingModal>
      <MergedPromosModal
        v-if="mergedPromosModal"
        v-model="mergedPromosModal"
        :selectedPromo="promo"
        @close="mergedPromosModal = false">
      </MergedPromosModal>
      <v-dialog v-model="showChangeWarningModal" persistent width="500">
        <v-card>
          <v-card-title>
           Promo Warnings
          </v-card-title>
          <v-card-text>
            Please confirm the following changes in <strong class="black--text">{{ promo.name }}</strong> before proceeding:
            <ul class="red--text pl-4 ma-0">
              <li v-for="(warning, index) in promoChangeWarnings" :key="index" class="mb-2" v-html="warning"></li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" text @click="closeShowChangeWarningModal">
              Cancel
            </v-btn>
            <v-btn color="primary" :disabled="saving" :loading="saving" @click="confirmSkipPromoChangeValidation">
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>
<script>
// Components
import PromoHeader from '@/components/PromoHeader.vue'
import PromoVendorSelect from '@/components/PromoVendorSelect.vue'
import PromoRelatedSubvendorSelect from '@/components/PromoRelatedSubvendorSelect.vue'
import PromoDates from '@/components/PromoDates.vue'
import itemTable from '@/components/items/itemsOnPromoTable.vue'
import storeTable from '@/components/stores/storesOnPromoTable.vue'
const CloneModal = () => import('@/components/CloneModal.vue')
const ShuttleModal = () => import('@/components/ShuttleModal.vue')
const StatusModal = () => import('@/components/StatusModal.vue')
const VendorApprovalModal = () => import('@/components/VendorApprovalModal.vue')
const ComplexMergingModal = () => import('@/components/ComplexMergingModal.vue')
const MergedPromosModal = () => import('@/components/MergedPromosModal.vue')
const PromoActions = () =>  import('@/components/PromoActions.vue')

// Mixins
import { displayAlert } from '@/mixins/alert'
import { userAccess } from '@/mixins/user-access'
import { utils } from '@/mixins/utils'
import { partySearch } from '@/mixins/party-search'
import { formValidation } from '@/mixins/form-validation'
// promo view component properties have been moved to this mixin so that it may be reused with ARG promo view
import { promoProperties } from '@/mixins/promo'

// Third-Party Helpers
import { addMinutes } from 'date-fns'

export default {
  name: 'promo-view-arg',
  data () {
    return {
      panelHeight: 310,
      ad_dt_picker: false,
      offer_start_dt_picker: false,
      offer_end_dt_picker: false,
      billing_week_dt_picker: false,
      refreshStores: false,
      complexMergingModal: false,
      mergedPromosModal: false
    }
  },
  watch: {
    'promo.vendor_invoice_exclude': {
      handler (newValue) {
        if (!newValue) {
          this.promo.internal_billing_party_id = null
        }
      }
    },
    'promo.manual_bill': {
      handler(newValue) {
        if (!newValue) {
          this.promo.billing_week_start = null
        }
    }
    }
  },
  computed: {
    isInFlight () {
      const startDate = this.startOfDay(this.promo.start_dt)
      const endDate = this.startOfDay(this.promo.end_dt)
      const isActive = this.currentDate >= startDate && this.currentDate <= endDate
      const isPast = this.currentDate > endDate
      const startDateDiff = (startDate - this.currentDate) / (1000 * 3600 * 24)
      const isNearTprEdlc = ['TPR', 'EDLC'].includes(this.promo.billing_mode?.constant) && this.promo.promo_category?.name !== 'TPR Non Allowance' && startDateDiff <= 28
      const isNearPerishableAd = this.promo.billing_mode?.constant === 'AD' && this.promo.perishable && startDateDiff <= 28
      const isNearNonPerishableAd = this.promo.billing_mode?.constant === 'AD' && !this.promo.perishable && startDateDiff <= 56
      return isActive || isPast || isNearTprEdlc || isNearPerishableAd || isNearNonPerishableAd
    },
    isPCAF() {
      return this.promo.billing_mode?.constant === 'PCAF'
    },
    promoIsAdCategory() {
      return (['AD', 'PCAF'].includes(this.promo.billing_mode?.constant) && !this.promoIsDSDOffInvoice)
    },
    promoIsDSDOffInvoice() {
      return this.promo.promo_category?.name === 'DSD Off Invoice'
    },
    showAdDateField() {
      return this.promoIsDSDOffInvoice || ['AD', 'PCAF'].includes(this.promo.billing_mode?.constant)
    },
    showDigitalCoupon () {
      return this.promoIsAdCategory
    },
    showSpecialAdLength () {
      return (this.promo?.promo_category?.billback_promotion)
        && (this.promoIsAdCategory && !this.dateExcludedCategories.includes(this.promo.promo_category.name)) || this.promoIsComplex
    },
    dateExcludedCategories () {
      const categories = this.userPromoCategories.filter(cat => {
        const normalizedName = cat.name?.toLowerCase()?.replaceAll('-', ' ')
        return (normalizedName.includes('day ad') || normalizedName.includes('non allowance')) && cat.billback_promotion === true
      })
      return categories.flatMap(cat => cat.name)
    },
    showDSD () {
      return (this.promo?.promo_category?.scan_promotion || this.promoIsDSDOffInvoice || this.promo.promo_category?.name === 'Ad Non Allowance')
    },
    showComplexMerging () {
      return this.promo.promo_category?.name === 'Mix Match' &&
        this.promo.promotion_type.constant === 'BUY_X_SAVE_$Y' &&
        this.hasStatusAdminAccess && this.isApprovedPromo
    },
    showMergedPromos () {
      return this.$auth.tenant === 'alliance-retail-group' && this.promo?.merged_from_promo_ids?.length > 0
    },
    showVendorInvoiceAndInternalBillingParty() {
      return !(this.isAMAPorEBA || this.promoIsDSDOffInvoice) && (this.isAdmin || this.isARGAdmin || this.userRoles.includes('arg-support'))
    },
    allowBillingEditing() {
      return (this.isAdmin || this.isARGAdmin || this.userRoles.includes('arg-support'))
    },
    allowedOfferStartDates () {
      return this.isAllowedOfferStartDate 
    },
    allowedOfferEndDates () {
      return this.isAllowedOfferEndDate
    },
    allowedBillingWeekDates () {
      return this.isAllowedBillingWeekDate
    },
    dateRules() {
      return { startDay: 0, endDay: 6 }
    },
    currentDate() {
      return this.startOfDay(new Date())
    },
    offerDatesAreNull() {
      return this.promo.offer_start_date === null && this.promo.offer_end_date === null
    },
    promoNameEditException () {
			return this.tenant === 'alliance-retail-group' && this.promo.status?.status?.constant === 'APPROVED' && (this.isAdmin || this.isARGAdmin || this.userRoles.some(role => ['arg-category-manager', 'arg-support'].includes(role)))
		},
		categoryManagerIsDisabled() {
			if (this.$auth.tenant === 'alliance-retail-group') {
				const statusConstant = this.promo.status?.status?.constant
				return ['INCLUDED_IN_MERGE', 'APPROVED'].includes(statusConstant) ? !(this.isAdmin || this.isARGAdmin || this.userRoles.some(role => ['arg-category-manager', 'arg-support'].includes(role))) : this.readOnlyPromo
			}
			return this.readOnlyPromo
		}
  },
  methods: {
    isValidAdDate (value) {
      if (this.promoIsAdCategory) {
        if (this.promo.ad_date  && this.promo.start_dt !== this.promo.ad_date) {
          return "Ad Date must be the same as Start Date"
        }
        return !!value || 'Ad Date is required'
      }
      return true
    },
    internalBillingPartyRules (value) {
      if (this.promo.vendor_invoice_exclude) {
        return !!value || 'Internal Billing Party is required'
      }
      return true
    },
    digitalCouponRules (value) {
      if (this.promo.digital_coupon) {
        return !!value || 'Digital Coupon Value is required'
      }
      return true
    },
    billingWeekStartRules (value) {
      if (this.promo.manual_bill) {
        return !!value || 'Billing Week Start is required'
      }
      return true
    },
    validateOfferDate (value, dateType) {
      if (this.offerDatesAreNull) {
        return true
      } else {
        const isStart = dateType === 'start'
        if (!value) {
          return isStart ? 'Start Date is required' : 'End Date is required'
        }
        
        const isAllowed = isStart ? this.isAllowedOfferStartDate(value) : this.isAllowedOfferEndDate(value)
        if (!isAllowed) {
          return 'Invalid weekday'
        }
        
        const otherDateExists = isStart ? this.promo.offer_end_date : this.promo.offer_start_date
        if (otherDateExists) {
          const isValid = this.validateOfferDateRange()
          const dateIsValid = isStart ? isValid.startDateIsValid : isValid.endDateIsValid
          if (!dateIsValid) {
            if (isStart) {
              this.offer_start_dt_picker = false
            } else {
              this.offer_end_dt_picker = false
            }
            return 'Invalid date range - Please ensure Perishable Offer Dates overlaps entire Promo date range'
          }
        }
      }

      return true
    },
    isValidOfferStartDate (value) {
      return this.validateOfferDate(value, 'start')
    },
    isValidOfferEndDate (value) {
      return this.validateOfferDate(value, 'end')
    },
    isAllowedOfferStartDate (val) {
      let allowed = true
      const numericDay = this.getNumericDay(val)
      if (this.dateRules.startDay != null ) {
        allowed = numericDay === this.dateRules.startDay
      }
      return allowed
    },
    isAllowedOfferEndDate (val) {
      let allowed = true
      const numericDay = this.getNumericDay(val)
      if (this.dateRules.endDay != null ) {
        allowed = numericDay === this.dateRules.endDay
      }
      return allowed
    },
    isAllowedBillingWeekDate(val) {
      const [year, month, day] = val.split('-').map(Number)
      const inputDate = new Date(year, month - 1, day)

      if (inputDate.getDay() !== 1) {
        return false
      }

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const threeWeeksAgo = new Date()
      threeWeeksAgo.setHours(0, 0, 0, 0)
      threeWeeksAgo.setDate(today.getDate() - 21)

      return inputDate.getTime() >= threeWeeksAgo.getTime()
    },
    validateOfferDateRange () {
      const { start_dt, end_dt } = this.promo
      const startDate = this.startOfDay(start_dt)
      const endDate = this.startOfDay(end_dt)
      const offerStartDate = this.startOfDay(this.promo.offer_start_date)
      const offerEndDate = this.startOfDay(this.promo.offer_end_date)
      
      const startDateIsValid = (offerStartDate <= startDate)
      const endDateIsValid = (offerEndDate >= endDate)

      return {startDateIsValid, endDateIsValid}
    },
    startOfDay (dateString) {
      const date = new Date(dateString)
      date.setHours(0, 0, 0, 0)
      return date
    },
    getNumericDay (value) {
      let date = new Date(value)
      date = addMinutes(date, date.getTimezoneOffset())
      return date.getDay()
    },
  },
  components: {
    itemTable,
    storeTable,
    CloneModal,
    ShuttleModal,
    StatusModal,
    VendorApprovalModal,
    ComplexMergingModal,
    MergedPromosModal,
    PromoHeader,
    PromoVendorSelect,
    PromoRelatedSubvendorSelect,
    PromoDates,
    PromoActions
  },
  mixins: [displayAlert, utils, userAccess, partySearch, promoProperties, formValidation]
}
</script>
<style scoped>
.active {
  background: #fff;
  color: #37474F !important;
}

@media (max-width: 1500px) {
  .display-dot {
    display: none;
  }
}
</style>